import { MarketplaceFilterMain } from "../../Marketplace/MarketplaceFilter/MarketplaceFilter.styled";
import { PriceFilter } from "../../Marketplace/MarketplaceFilter/PriceFilter";
import { SaleTypeFilter } from "../../Marketplace/MarketplaceFilter/SaleTypeFilter";
import { ProfileMobileFilterWrapper } from "./ProfileMobileFilter.styled";

export const ProfileMobileFilter = () => {
  return (
    <ProfileMobileFilterWrapper>
      <div className='container'>
        <div className='filter_wrapper'>
          <MarketplaceFilterMain>
            <PriceFilter />
            <SaleTypeFilter />
          </MarketplaceFilterMain>
        </div>
      </div>
    </ProfileMobileFilterWrapper>
  );
};
